<ul class="list-group list-group-flush team-member-list">
  <li *ngFor="let usr of studyVM.userList">
    <div class="col-1 image">
      <i class="material-icons"> account_circle </i>
    </div>
    <div class="col-4 usrDetail">
      <span class="name">{{ usr.user.preferredName }}</span>
      <span class="email-add">{{ usr.user.emailAddress }}</span>
      <span class="email-add">{{ usr.user.officeLocation }}</span>
    </div>
    <div class="col-6 role" *ngIf="usr.roleId === 1">
      <label for="disp-access">Access Level</label>
      <span class="actualdata">{{ getRoleText(usr.roleId) }}</span>
    </div>
  </li>
</ul>
